export default "__VITE_ASSET__CoAHV5QD__"